import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";
import FormCheckbox from "app/Components/_form/FormCheckbox/FormCheckbox";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import {
  DDMMYYYYHHMMAFormat,
  disableFutureDate,
  vflScheduledDate,
  YYYYMMDDHHMMAFormat,
} from "app/_helpers/dateHelper";
import { userDropdownLabel } from "app/_helpers/helper";
import { useEmployee, useEmployeeDropdown } from "app/_helpers/hooks";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import {
  isUserMM,
  IS_USER_SITE_MINES,
  IS_USER_SITE_HO,
  getAuthUser,
} from "../../IncidentManagement/Helper";
import { Department, VFL_STATUS } from "../CONSTANTS";

function VFLScheduleForm({
  form,
  onChange,
  onChangeDate,
  error,
  VFLExecutives,
  mines,

  area,
  subArea,
  activity,
  subActivity,
  sites,

  completionFlag = false,
  vflExecution = false,
  contractors,
}) {
  const [, employeesOption] = useEmployeeDropdown();
  const [finalContractors, setFinalContractors] = useState([]);
  const employeeActiveOptions = employeesOption?.filter(
    (obj) => obj?.employmentStatus === "active"
  );
  const l = employeeActiveOptions.length;
  const isUserSiteHo = IS_USER_SITE_HO();
  const isUserSiteMines = IS_USER_SITE_MINES();
  const loggedInUserData = getAuthUser();
  const employeesFiltered = new Array();
  if (isUserSiteHo || loggedInUserData?.role.roleLable == "1") {
    let j = 0;
    for (let i = 0; i < l; i++) {
      if (employeeActiveOptions[i].siteType == 1) {
        employeesFiltered[j] = employeeActiveOptions[i];
        j = j + 1;
      }
    }
  }
  // console.log("employeesFiltered", employeesFiltered);
  if (isUserSiteMines || loggedInUserData?.role.roleLable == "7") {
    let j = 0;
    for (let i = 0; i < l; i++) {
      if (employeeActiveOptions[i].siteType == 3) {
        employeesFiltered[j] = employeeActiveOptions[i];
        j = j + 1;
      }
    }
  }

  const mineSite = useMemo(() => IS_USER_SITE_MINES(), []);
  const mmFlag = useMemo(
    () =>
      form?.vflStatus === VFL_STATUS.scheduled && isUserMM() && !form?.executiveReturn,
    [form?.executiveReturn, form?.vflStatus]
  );

  useEffect(() => {
    setFinalContractors((prev) =>
      contractors?.filter((obj) =>
        obj?.contractorSiteHistoryData?.find((site) =>
          site?.siteId === form?.mineId ? true : false
        )
      )
    );
  }, [contractors, form?.mineId]);

  return (
    <Row>
      <Col lg={4}>
        {completionFlag ? (
          <FormInput
            readOnly={true}
            label={"VFL Executive (Team Leader)"}
            name="vflExecutiveId"
            value={`${form?.vflOfficerData?.firstName} ${form?.vflOfficerData?.lastName}`}
            onChange={onChange}
            error={error?.vflExecutiveId}
            disabled
          />
        ) : (
          <FormSelect
            label={"VFL Executive (Team Leader)"}
            name="vflExecutiveId"
            value={form?.vflExecutiveId}
            onChange={onChange}
            options={VFLExecutives}
            error={error?.vflExecutiveId}
            disabled={completionFlag || mmFlag}
          ></FormSelect>
        )}
      </Col>
      <Col md="8">
        <div className="form-group">
          <label>Team Members</label>
          <MultiSelectWithCheckbox
            options={employeesFiltered.map((d) => ({
              ...d,
              disabled:
                form?.employeeIds?.split(",")?.length === 4 &&
                form?.employeeIds?.split(",")?.includes(d.id.toString())
                  ? false
                  : form?.employeeIds?.split(",")?.length < 4 || !form?.employeeIds
                  ? false
                  : true,
            }))}
            value={form?.employeeIds
              ?.split(",")
              ?.map((id) => {
                const found = employeesFiltered.find((site) => site.id === +id);
                return found ? { ...found } : null;
              })
              ?.filter((d) => !!d)}
            onChange={(selectedSites) => {
              onChange({
                target: {
                  name: "employeeIds",
                  value: selectedSites?.map((site) => site.id).join(","),
                },
              });
            }}
            disabled={completionFlag || mmFlag}
            hasSelectAll={false}
            disableSearch={false}
          />
          {/* <span className="text-danger small">{errorForm.siteIds}</span> */}
        </div>
      </Col>
      {form?.employeeIds && (
        <Col md="12">
          <div className="form-group">
            <label>Team Members</label>

            <div className="teamSection">
              {form?.employeeIds?.split(",")?.map((id) => {
                const found = employeesFiltered.find((site) => site.id === +id);
                return (
                  <>
                    {found && (
                      <span className="position-relative emp-section">
                        <span className="empTab">{found?.label}</span>
                        {!completionFlag && !mmFlag && (
                          <span
                            className="icons text-danger"
                            onClick={(e) => {
                              onChange({
                                target: {
                                  name: "employeeIds",
                                  value: form?.employeeIds
                                    ?.split(",")
                                    ?.filter((id) => +id !== found?.value)
                                    .join(","),
                                },
                              });
                            }}
                          >
                            <FaTimes />
                          </span>
                        )}
                      </span>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </Col>
      )}
      <Col lg={4} className="pt6">
        <FormDateTimePicker
          isValidDate={vflScheduledDate}
          value={form.vflScheduledDateTime}
          name="vflScheduledDateTime"
          onChange={onChangeDate}
          // timeFormat={"HH:mm:ss"}
          dateFormat="YYYY-MM-DD"
          label={"VFL Schedule Date"}
          error={error?.vflScheduledDateTime}
          disabled={completionFlag}
        />
      </Col>
      <Col lg={4} className="pt6">
        <FormSelect
          label={"Mine Name"}
          name="mineId"
          value={form?.mineId}
          onChange={onChange}
          options={mines}
          KEY_label={"name"}
          error={error?.mineId}
          disabled={completionFlag || mineSite || mmFlag}
        ></FormSelect>
      </Col>
      <Col lg={4}>
        <div className="contractorInvolvedField">
          <FormCheckbox
            type="checkbox"
            name="contractorInvolved"
            checked={form?.contractorInvolved}
            onChange={onChange}
            label={"Contractor Involved"}
            disabled={completionFlag || mmFlag}
          />
        </div>
        <FormSelect
          label={""}
          name="contractorsId"
          value={form?.contractorsId}
          onChange={onChange}
          options={finalContractors}
          error={error?.contractorsId}
          KEY_label={"contractorLegalEntity"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag || !form?.contractorInvolved}
        ></FormSelect>
      </Col>
      {completionFlag && (
        <Col lg={4}>
          <FormDateTimePicker
            isValidDate={disableFutureDate}
            value={form.vflCompletionDateTime}
            name="vflCompletionDateTime"
            onChange={onChangeDate}
            // timeFormat={"HH:mm:ss"}
            dateFormat="YYYY-MM-DD"
            label={"VFL Conducted On"}
            error={error?.vflCompletionDateTime}
            disabled={vflExecution || mmFlag}
          />
        </Col>
      )}
      <Col lg={4}>
        <FormInput
          readOnly={true}
          name="regionalOfficeId"
          value={form.regionalOfficeId || ""}
          type="text"
          label={"Regional Office"}
          error={error?.regionalOfficeId}
          disabled
        />
      </Col>
      <Col lg={4}>
        <FormSelect
          label={"Department"}
          name="departmentId"
          value={form?.departmentId}
          onChange={onChange}
          options={Department}
          error={error?.departmentId}
          // KEY_label={"name"}
          // KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag}
        ></FormSelect>
      </Col>

      <Col lg={4}>
        <FormSelect
          label={"Area of Operation"}
          name="areaId"
          value={form?.areaId}
          onChange={onChange}
          options={area}
          error={error?.areaId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag}
        ></FormSelect>
      </Col>
      <Col lg={4}>
        <FormSelect
          label={"Sub Area of Operation"}
          name="subAreaId"
          value={form?.subAreaId}
          onChange={onChange}
          options={subArea}
          error={error?.subAreaId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag}
        ></FormSelect>
      </Col>
      {form?.subAreaId === 0 && (
        <Col lg={4}>
          <FormInput
            label={"Other Sub Area"}
            name="otherSubArea"
            value={form?.otherSubArea}
            onChange={onChange}
            error={error?.otherSubArea}
            disabled={completionFlag}
          ></FormInput>
        </Col>
      )}
      <Col lg={4}>
        <FormSelect
          label={"Activity"}
          name="activityId"
          value={form?.activityId}
          onChange={onChange}
          options={activity}
          error={error?.activityId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag}
        ></FormSelect>
      </Col>
      <Col lg={4}>
        <FormSelect
          label={"Sub Activity"}
          name="subActivityId"
          value={form?.subActivityId}
          onChange={onChange}
          options={subActivity}
          error={error?.subActivityId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled={completionFlag || mmFlag}
        ></FormSelect>
      </Col>

      <Col lg={4}>
        <FormInput
          label={"Location ID"}
          name="locationSiteId"
          value={form?.locationSiteId || ""}
          onChange={onChange}
          options={sites}
          error={error?.locationSiteId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled
        />
      </Col>
      <Col lg={4}>
        <FormInput
          label={"RO ID"}
          name="roSiteId"
          value={form?.roSiteId || ""}
          onChange={onChange}
          options={sites}
          error={error?.roSiteId}
          KEY_label={"name"}
          KEY_value={"id"}
          blankSelect={"Select"}
          disabled
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={"State"}
          name="stateMasterId"
          value={form?.stateMasterId || ""}
          disabled
        />
      </Col>
      <Col lg={4}>
        <FormInput
          label={"Country"}
          name="countryMasterId"
          value={form?.countryMasterId || ""}
          disabled
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={"VFL Scheduled By"}
          name="countryMasterId"
          value={userDropdownLabel(form?.schedularData || getAuthUser()?.user)}
          disabled
        />
      </Col>

      <Col lg={4}>
        <FormInput
          label={"VFL System Time Stamp"}
          name="vflScheduledFillDateTime"
          value={
            form?.vflScheduledFillDateTime
              ? DDMMYYYYHHMMAFormat(form?.vflScheduledFillDateTime)
              : DDMMYYYYHHMMAFormat()
          }
          disabled
        />
      </Col>

      {completionFlag && (
        <>
          <Col lg={4}>
            <FormInput
              label={"VFL Completion Time Stamp"}
              name="vflCompletionFillDateTime"
              value={
                form?.vflCompletionFillDateTime
                  ? DDMMYYYYHHMMAFormat(form?.vflCompletionFillDateTime)
                  : DDMMYYYYHHMMAFormat()
              }
              disabled
            />
          </Col>
          <Col lg={4}>
            <FormInput
              label={"VFL Completed By"}
              name="countryMasterId"
              value={userDropdownLabel(form?.vflCompletedByData || getAuthUser()?.user)}
              disabled
            />
          </Col>
        </>
      )}

      <Col lg={12}>
        <FormTextArea
          label={"VFL Description"}
          name="description"
          onChange={onChange}
          value={form?.description || ""}
          disabled={completionFlag || mmFlag}
        />
      </Col>
    </Row>
  );
}

export default VFLScheduleForm;
